import { Component, OnInit } from '@angular/core';
import { Validators, UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { BackendService } from '../core/services/backend-prod.service';
import { HelperService } from '../core/services/helper.service';
import { CustomPasswordValidators } from './custom-password-validators';
import { Storage } from '@ionic/storage';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.page.html',
  styleUrls: ['./change-password.page.scss'],
})
export class ChangePasswordPage implements OnInit {

  changePasswordform: UntypedFormGroup;
  // submitted: boolean = false;
  token: any;
  regemail: any;
  currentPasswordHide = true;
  newPasswordHide = true;
  confirmPasswordHide = true;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private backendService: BackendService,
    private router: Router,
    public storage: Storage,
    public helperService: HelperService
  ) { } 

  ngOnInit() {
    this.currentPasswordHide = true;
    this.newPasswordHide = true;
    this.confirmPasswordHide = true;
    this.changePasswordform = this.formBuilder.group({
      'currentPassword': [
        '', 
        Validators.compose([Validators.required])
      ],
      'newPassword': [
        '',
        Validators.compose([
          // check whether the entered password has a number
          CustomPasswordValidators.patternValidator(/\d/, {
            hasNumber: true
          }),
          // check whether the entered password has a upper case letter
          CustomPasswordValidators.patternValidator(/[A-Z]/, {
            hasUpperCase: true 
          }),
          // check whether the entered password has a lower case letter
          CustomPasswordValidators.patternValidator(/[a-z]/, {
            hasSmallCase: true
          }),
          // check whether the entered password has a special character
          CustomPasswordValidators.patternValidator(
            /[ !@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/,
            {
              hasSpecialCharacters: true
            }
          ),
          Validators.minLength(8)
        ])
      ],
      'confirmPassword': [''],
    },
    {
      // check whether our password and confirm password match
      validator: CustomPasswordValidators.passwordMatchValidator
    });

  }
  
  get changePasswordControls() { return this.changePasswordform.controls; }

  async getStorage () {
    let data = {
      token: await this.storage.get("token"),
      userId: await this.storage.get("id")
    }
    return data;
  }

  onChangePasswordSubmit() {
    // this.submitted = true;
    if (this.changePasswordform.invalid) {
      this.helperService.presentToast("Form incomplete", 2000);
      return;
    }

    this.getStorage().then((_storage)=>{
      if(_storage){
        let payload = {
          current_password: this.changePasswordform.value.currentPassword,
          new_password: this.changePasswordform.value.newPassword 
        }
        this.helperService.loader();
        this.backendService.PostAPICall('changeUserPassword', payload, _storage.token)
          .subscribe(
            (data) => {
                // this.submitted = false;
                this.changePasswordform.reset();
                this.helperService.closeLoader();
                this.helperService.presentToast('Password has been changed successfully.', 2000);
                this.storage.clear();
                this.router.navigate(['login']);
            },
            (error) => {
              this.helperService.closeLoader();
              this.helperService.handleError(error);
            })
      }else{
        this.helperService.presentToast("Oops! Something went wrong", 2000);
      }
    
    })
  }

  login(){
    this.storage.clear();
    this.router.navigate(['/login']);
  }


}
